import { SentryConfigOptions } from '@/composables';

export type Configuration = {
  cognito?: {
    userPoolId: string;
    userPoolClientId: string;
  };
  portalApi: string;
  environment: Environment;
  webTemplateStyleSheetUrl: string;
  mapbox: {
    token?: string;
    overlaysTileSet?: string;
    overlayTileSetLayers?: {
      // TODO: Update these as needed.
      dfesRegions: string;
      lga: string;
      lgaCentres: string;
      pastoralStations: string;
    };
  };
  gaTagId?: string;
  sentry?: SentryConfigOptions;
  remoteHazardAssets: {
    iconAssetsPathSvg: string;
    iconAssetsPathPng: string;
  };
  geospatialBucket: string;

  // TODO: Remove these or update them as needed.
  windTileBaseUrl: string;
  externalTileBaseUrl: string;
};

export type Environment = (typeof ENVIRONMENTS)[number];

export const ENVIRONMENTS = ['local', 'dev', 'uat', 'uat-gv', 'prd', 'prd-training', 'prd-gv'] as const;
export const DEFAULT_ENVIRONMENT: Environment = 'prd';
export const CLIENT_APP = 'eca';
export const PARTITION_KEY = 'x-gv-client';

export const HOSTNAMES_TO_ENVIRONMENTS: Record<string, Environment> = {
  // !Production hostnames. Please DO NOT TOUCH these unless you know what you are doing.
  // !Refer to the infra/cfg/au-prd-config.ts.

  // !Production hostnames.
  'mbready.manitoba.ca': 'prd',

  // !Production training hostnames.
  'prd-training.eca.genvis.com': 'prd-training',

  // !Production Genvis (internal) training hostnames.
  'prd-gv.eca.genvis.com': 'prd-gv',

  // !UAT hostnames.
  'uatmbready.manitoba.ca': 'uat',

  // !UAT Genvis (internal) hostnames.
  'eca.uat.portal.genvis.com': 'uat-gv',
  'www.eca.uat.portal.genvis.com': 'uat-gv',

  // !Development hostnames.
  'eca.dev.portal.genvis.com': 'dev',
  'www.eca.dev.portal.genvis.com': 'dev',

  // !Local hostnames.
  localhost: 'local',
};
